'use client';

import { createContext, use } from 'react';
export type EmbeddedControlBarSurface = 'normal' | 'fullscreen';

/** The embedded Control Bar surface, or null outside the embedded Control Bar. */
export const EmbeddedControlBarContext = createContext<EmbeddedControlBarSurface | null>(null);
export function useEmbeddedControlBarSurface() {
  return use(EmbeddedControlBarContext);
}

/** True in both the normal view and native fullscreen of the embedded Control Bar. */
export function useIsEmbeddedControlBar() {
  return useEmbeddedControlBarSurface() !== null;
}